import type {
  DataNodeCreatedEvent,
  DataRelationCreatedEvent,
  DataRelationDeletedEvent
} from 'api/data/events/signalREvents';
import type { TreeSyncContext } from 'api/decomposition-tree/treeSyncContext';
import {
  onNodeCreated,
  onNodeCreatedWithRelation,
  onRelationCreated,
  onRelationDeleted
} from 'features/tree-view/model/treeLiveSync';

export function handleNodeCreatedEvent(event: DataNodeCreatedEvent, context: TreeSyncContext): void {
  // Routing relies on the Payload.ParentNodeId on every child-create event.
  // A child event that arrives without it would be treated as a root add and pinned at the root.
  if (event.Payload.ParentNodeId) {
    onNodeCreatedWithRelation(event, context);
  } else {
    onNodeCreated(event, context);
  }
}

export function handleRelationDeletedEvent(event: DataRelationDeletedEvent, context: TreeSyncContext): void {
  onRelationDeleted(event, context);
}

export function handleRelationCreatedEvent(event: DataRelationCreatedEvent, context: TreeSyncContext): void {
  onRelationCreated(event, context);
}
